module.exports = __webpack_public_path__ + "static/media/informations-disabled.96ec5a5f.svg";